export default "__VITE_ASSET__f5203afc__"